module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "move"
  }, [_c('div', {
    staticClass: "mo_content"
  }, [_c('p', {
    staticClass: "mo_con"
  }, [_vm._v("-- 限时特惠距活动结束仅剩 --")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "time",
      rawName: "v-time",
      value: (_vm.time),
      expression: "time"
    }],
    staticClass: "mo_time"
  }, [_c('span', {
    staticClass: "time time1"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "time time2"
  }, [_vm._v("0")]), _vm._v(" "), _c('span', {
    staticClass: "time3"
  }, [_vm._v("时")]), _vm._v(" "), _c('span', {
    staticClass: "time time4"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "time time5"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "time6"
  }, [_vm._v("分")]), _vm._v(" "), _c('span', {
    staticClass: "time time7"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "time time8"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "time9"
  }, [_vm._v("秒")]), _vm._v(" "), _c('span', {
    staticClass: "time time10"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "time time11"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "fmove"
  }, [_c('ul', {
    directives: [{
      name: "shift",
      rawName: "v-shift"
    }],
    staticClass: "bomove clearfix"
  }, _vm._l((_vm.liactive), function(lia, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": '#/detail/' + lia.item_id
      }
    }, [_c('img', {
      attrs: {
        "src": lia.image
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mo_price"
    }, [_vm._v(_vm._s(lia.discountPrice) + " "), _c('span', {
      staticClass: "old_price"
    }, [_vm._v(_vm._s(lia.price))])]), _vm._v(" "), _c('button', {
      staticClass: "mo_buy"
    }, [_vm._v("立即抢购")])])])
  }))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-74ec8db6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-74ec8db6","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/pmove.vue
// module id = 115
// module chunks = 0